import { z } from "zod";
import { RequestValidationErrorTypeSchema } from "../Enums/RequestValidationErrorType";
import { BaseOutputSchema } from "./BaseOutput";

export const CreatedRequestOutputSchema = BaseOutputSchema.extend({
    requestId: z.string().nullish(),
    success: z.boolean(),
    shouldBeNotifiedValue: z.boolean(),
    idValidationError: z.boolean(),
    invalidFieldId: z.string().nullish(),
    attachmentsRequired: z.boolean(),
    attachmentsEnabled: z.boolean(),
    requestValidationErrorType: RequestValidationErrorTypeSchema.nullish(),
    bsignUrl: z.string().nullish(),
    isManuallySigned: z.boolean().nullable()
});

export type CreatedRequestOutput = z.infer<typeof CreatedRequestOutputSchema>;
